import React from 'react';
import { ErrorMessage as ErrorMessageContainer } from '@hookform/error-message';
import { Box, Button, Stack } from '@mui/material';

import EnquiryInfoDatePicker from 'venuescanner-js/react/components/Inbox/components/Enquiry/EnquiryInfoDatePicker';
import EnquiryInfoAddMessage from 'venuescanner-js/react/components/Inbox/components/Enquiry/EnquiryInfoAddMessage';
import EnquiryCtas from 'venuescanner-js/react/components/Inbox/components/Enquiry/EnquiryCtas/index.js';
import { ErrorMessage } from 'venuescanner-js/react/components/Inbox/components/Enquiry/Enquiry';
import 'venuescanner-js/react/components/Inbox/components/Enquiry/EnquiryInfoInput/EnquiryInfoInput.scss';
import TextField from 'venuescanner-js/react/components/Inbox/components/Enquiry/TextField';
import InputLabel from 'venuescanner-js/react/components/Inbox/components/Enquiry/InputLabel';

const EnquiryEdit = ({
  thread,
  register,
  onSubmit,
  errors,
  onCancel,
  control,
  header,
}) => {
  return (
    <>
      <Box className='enquiry enquiry-details'>
        {header}
        <Stack
          component='form'
          id='editForm'
          onSubmit={onSubmit}
          direction='column'
          spacing={1.5}>
          <Box className='enquiry-info'>
            <TextField
              inputProps={{
                name: 'capacity',
                id: 'capacity',
                type: 'number',
                ...register('capacity'),
              }}
              errors={errors}
              label='Guests'
              name='capacity'
              containerSx={{ mb: 1.5 }}
            />

            <Stack
              sx={{ mb: 1.5 }}
              className='enquiry-date-picker'
              direction='column'
              spacing={1.5}>
              <InputLabel name='date-range' label='Date' />
              <EnquiryInfoDatePicker
                className='enquiry-edit__date-picker'
                id='date-range'
                name='dateRange'
                errors={errors}
                control={control}
              />
              <ErrorMessageContainer
                errors={errors}
                name='dateRange'
                as={ErrorMessage}
              />
            </Stack>

            <Stack direction='column' spacing={1.5} sx={{ pb: 0.5 }}>
              <InputLabel name='date-range' label='Time' />
              <fieldset>
                <legend className='visually-hidden'>Event times</legend>
                <div className='enquiry-edit__time-range'>
                  <div className='enquiry-edit__time-range-item'>
                    {/* https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/time#examples */}
                    <label htmlFor='startTime' className='visually-hidden'>
                      Start time
                    </label>
                    <input
                      {...register('start')}
                      type='time'
                      id='startTime'
                      min='00:00'
                      max='23:59'
                    />
                  </div>
                  -
                  <div className='enquiry-edit__time-range-item'>
                    <label htmlFor='endTime' className='visually-hidden'>
                      End time
                    </label>
                    <input
                      {...register('end')}
                      type='time'
                      id='endTime'
                      min='00:00'
                      max='23:59'
                    />
                  </div>
                </div>
              </fieldset>
              <ErrorMessageContainer
                errors={errors}
                name='start'
                as={ErrorMessage}
              />
              <ErrorMessageContainer
                errors={errors}
                name='end'
                as={ErrorMessage}
              />
            </Stack>
          </Box>
          <Box className='enquiry-info' sx={{ pb: 2 }}>
            <EnquiryInfoAddMessage
              label='Message'
              placeholder='Please provide details about what is included in your quote, inclduing relevant package or menu information'
              register={register}
            />
          </Box>
        </Stack>
        <EnquiryCtas sx={{ mt: 'auto', pb: 2 }}>
          <Button
            variant='contained'
            type='submit'
            size='medium-large'
            form='editForm'
            color='primary'
            fullWidth>
            {thread.can.REOPEN ? 'Re-open' : 'Send'}
          </Button>
          <Button
            size='medium-large'
            fullWidth
            variant='outlined'
            color='primary'
            onClick={onCancel}>
            Cancel
          </Button>
        </EnquiryCtas>
      </Box>
    </>
  );
};

export default EnquiryEdit;
